<div class="tw-flex hover:tw-text-black tw-gap-4 tw-justify-center tw-items-center tw-h-full tw-bg-yellowLight tw-py-6 tw-px-2">
  <img [width]="100" src="assets/images/how-pumpumpum-works.svg" alt="">
  <div>
    <p class="tw-font-bold tw-text-3xl">How</p>
    <p class="tw-font-bold tw-text-3xl">PumPumPum</p>
    <p class="tw-font-bold tw-text-3xl">Works?</p>
    <br>
    <a href="/how-pumpumpum-works"><button class="tw-px-4 tw-py-2 tw-bg-yellow tw-text-white hover:tw-text-white tw-rounded-md">LEARN MORE</button></a>
  </div>
</div>
